import React, { useState } from "react";
import MenuSearchForm from "/react4xp/components/shared/MenuSearchForm/MenuSearchForm";

interface TMenuItem {
    label: string;
    url?: string;
    children?: TMenuItem[];
}

interface HageMenuProps {
    menu: TMenuItem[];
    isOpen: boolean;
    onClose: () => void;
    homeUrl?: string;
}

const CloseIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
);

const ChevronIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
        <polyline points="6 9 12 15 18 9" />
    </svg>
);

function HageMenuItem({ item, onClose }: { item: TMenuItem; onClose: () => void }) {
    const [open, setOpen] = useState(false);
    const hasChildren = !!item.children?.length;

    return (
        <li className={`hage-menu__item${open ? " hage-menu__item--open" : ""}`}>
            <div className="hage-menu__item-row">
                {item.url ? (
                    <a href={item.url} className="hage-menu__link" onClick={onClose}>
                        {item.label}
                    </a>
                ) : (
                    <span className="hage-menu__link">{item.label}</span>
                )}
                {hasChildren && (
                    <button
                        className="hage-menu__chevron-btn"
                        onClick={() => setOpen((v) => !v)}
                        aria-expanded={open}
                        aria-label={open ? "Skjul undermeny" : "Vis undermeny"}
                    >
                        <ChevronIcon />
                    </button>
                )}
            </div>
            {hasChildren && open && (
                <ul className="hage-menu__submenu">
                    {item.children!.map((child, idx) => (
                        <HageMenuItem key={idx} item={child} onClose={onClose} />
                    ))}
                </ul>
            )}
        </li>
    );
}

const HageMenu: React.FC<HageMenuProps> = ({ menu, isOpen, onClose, homeUrl = "/" }) => {
    return (
        <div
            className={`hage-menu${isOpen ? " hage-menu--open" : ""}`}
            aria-hidden={!isOpen}
            aria-modal={isOpen}
            role="dialog"
            aria-label="Navigasjonsmeny"
        >
            <div className="hage-menu__backdrop" onClick={onClose} aria-hidden="true" />
            <div className="hage-menu__panel">
                <div className="hage-menu__panel-header">
                    <button
                        className="hage-menu__close"
                        onClick={onClose}
                        aria-label="Lukk meny"
                    >
                        <CloseIcon />
                        <span>Lukk</span>
                    </button>
                </div>
                <MenuSearchForm homeUrl={homeUrl} />
                <nav className="hage-menu__nav" aria-label="Sidenavigasjon">
                    <ul className="hage-menu__list">
                        {menu.map((item, idx) => (
                            <HageMenuItem key={idx} item={item} onClose={onClose} />
                        ))}
                    </ul>
                </nav>
            </div>
        </div>
    );
};

export default HageMenu;
